import type { LetterSenderProviderConfig } from './constants';

export const MB = 1024 * 1024;
const DEFAULT_LETTER_SENDER_MAX_FILE_SIZE_MB = 4;
const DEFAULT_LETTER_SENDER_MAX_FILE_SIZE_BYTES =
  DEFAULT_LETTER_SENDER_MAX_FILE_SIZE_MB * MB;
const DEFAULT_LETTER_SENDER_MAX_FILES = 5;

export const DEFAULT_LETTER_SENDER_CONFIG = {
  accept: {
    'application/pdf': ['.pdf'],
  },
  maxFiles: DEFAULT_LETTER_SENDER_MAX_FILES,
  maxSize: DEFAULT_LETTER_SENDER_MAX_FILE_SIZE_BYTES,
  maxCombinedFileSize:
    DEFAULT_LETTER_SENDER_MAX_FILES * DEFAULT_LETTER_SENDER_MAX_FILE_SIZE_BYTES,
} satisfies Required<LetterSenderProviderConfig>;
